import Vessel from "@/assets/icons/vessel.svg?react";
import { Paths } from "@/core/constants/paths";
import { decodeJwt, getAuthToken, hasAnyScope, SCOPE_HUB_WEB } from "@/modules/auth";
import type { NavigatorItem } from "@/shared/components";

const MENU_ITEMS: NavigatorItem[] = [
  {
    label: "Início",
    icon: "home",
    path: Paths.HOME,
    testId: "nav-inicio",
    scopes: [SCOPE_HUB_WEB],
  },
  {
    // O acesso ao módulo é decidido pela API (privilégio `hub.financeiro:visualizar-painel`):
    // sem ele a listagem apresenta o estado de "sem permissão" a partir do 403.
    label: "Financeiro",
    icon: "dollar",
    path: Paths.FINANCEIRO_OBRAS,
    testId: "nav-financeiro",
    end: false,
    scopes: [SCOPE_HUB_WEB],
  },
  {
    label: "Obras",
    // Figma "novo menu" 708-22166: th-large.
    icon: "th-large",
    path: Paths.OBRAS,
    testId: "nav-obras",
    end: false,
    scopes: [SCOPE_HUB_WEB],
  },
  {
    // O acesso ao módulo é decidido pela API (privilégio `hub.equipe:visualizar`):
    // sem ele cada aba apresenta o estado de "sem permissão" a partir do 403.
    label: "Recursos",
    icon: "briefcase",
    path: Paths.RECURSOS,
    testId: "nav-recursos",
    end: false,
    scopes: [SCOPE_HUB_WEB],
  },
  {
    // O acesso ao módulo é decidido pela API (privilégio `hub.embarcacao:visualizar`):
    // sem ele a listagem apresenta o estado de "sem permissão" a partir do 403.
    label: "Embarcações",
    // Ícone do módulo; o `Icon` do DS não tem o navio preenchido.
    icon: Vessel,
    path: Paths.EMBARCACOES,
    testId: "nav-embarcacoes",
    scopes: [SCOPE_HUB_WEB],
  },
];

function canAccess(item: NavigatorItem, token: string | null): boolean {
  if (!item.scopes?.length) return true;
  if (!token) return false;
  if (!decodeJwt(token)?.scope) return true;
  return hasAnyScope(token, item.scopes);
}

export function useMenuItems(): NavigatorItem[] {
  const token = getAuthToken();
  return MENU_ITEMS.filter((item) => canAccess(item, token));
}

const SECONDARY_MENU_ITEMS: NavigatorItem[] = [
  {
    // O acesso ao módulo é decidido pela API (claims `hub.auditoria:visualizar`, `hub.perfil:visualizar`,
    // `hub.permissao:visualizar` e `hub.usuario:visualizar`): sem elas cada aba apresenta o estado de
    // "sem permissão" a partir do 403.
    label: "Painel de Controle",
    icon: "cog",
    path: Paths.CONTROL_PANEL,
    testId: "nav-painel-de-controle",
    end: false,
    scopes: [SCOPE_HUB_WEB],
  },
];

export function useSecondaryMenuItems(): NavigatorItem[] {
  const token = getAuthToken();
  return SECONDARY_MENU_ITEMS.filter((item) => canAccess(item, token));
}
